import { useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { SequenceMenu, useNotifications } from '@sequencehq/core-components'
import { usePermissions } from 'lib/rbac'

const TOAST_ID = 'invoice.menuItem.markAsUncollectible'
export const MarkAsUncollectible = (props: {
  invoiceId: string
  invoiceNumber: string | undefined
  onSuccess?: () => void
}) => {
  const { displayNotification } = useNotifications()
  const { can } = usePermissions()

  const uncollectibleMutation = useMutation(
    dashboard20240730Client.putInvoicePaymentStatus,
    {
      onSuccess: () => {
        displayNotification(
          `Invoice ${props.invoiceNumber || ''} marked as uncollectible`,
          {
            type: 'success',
            id: TOAST_ID
          }
        )
        props.onSuccess?.()
      },
      onError: () => {
        displayNotification(
          `Invoice ${props.invoiceNumber || ''} could not be updated`,
          {
            type: 'error',
            id: TOAST_ID
          }
        )
      }
    }
  )

  if (!can('org.invoice:update')) {
    return null
  }

  return (
    <SequenceMenu.Item
      data-testid="invoices.markAsUncollectible.menuItem"
      uuid="mark-as-uncollectible"
      label="Mark as uncollectible"
      onClick={() => {
        displayNotification(
          `Marking invoice ${props.invoiceNumber || ''} as uncollectible...`,
          {
            type: 'info',
            id: TOAST_ID
          }
        )
        uncollectibleMutation.mutate({
          invoiceId: props.invoiceId,
          paymentStatus: 'UNCOLLECTIBLE'
        })
      }}
    />
  )
}
